import React from "react";
import { useMediaQuery } from "react-responsive";
import User from "src/app/models/User";
import { TableProvider } from "../context/TableContext";

import TableHeader from "../component/TableHeader";
import MemberStatusFilter from "../component/MemberStatusFilter";

import MemberPagination from "../component/pagination/MemberPagination";
import MemberTable from "../component/table/MemberTable";
import MemberCard from "../component/card/MemberCard";

/**
 *
 */

const MemberList = () => {
  const isMobileView = useMediaQuery({ query: "(max-width: 900px)" });
  console.log("test workspace");
  return (
    <>
      <TableProvider<User> collection="users">
        <div
          style={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            // justifyContent: "space-between",
          }}
        >
          <div className="card py-2">
            <MemberStatusFilter />
          </div>
          <div className="card py-2 my-2 bg-transparent" />
          <div
            style={{
              height: "100%",
              overflow: "hidden",
            }}
            className="card p-3"
          >
            <TableHeader />

            {isMobileView && <MemberCard />}
            {!isMobileView && <MemberTable />}

            <MemberPagination />
          </div>
        </div>

        {/* <OrderModal />
        <ModalExportOrder /> */}
      </TableProvider>
    </>
  );
}

export default MemberList;